import React, { useEffect, useState } from "react";
import { Row, Col } from "../../ui/Grid";
import Skeleton from "../../ui/Skeleton";

import claimedImage from "../../FormLocalSearch/assets/audit/revendication.png";
import category from "../../FormLocalSearch/assets/audit/categorie.png";
import ProgressCircle from "../ProgressCircle";
import useLang from "../../../i18n/useLang";
import content from "./content";

const Essentials = ({ auditInfo }) => {
  const all = content[useLang()];
  const t = all.essentials;
  const [score, setScore] = useState();
  const [categories, setCategories] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getScore = async () => {
      let score = 0;
      if (auditInfo.IsCompanyClaimed) {
        score = score + 50;
      }
      if (auditInfo.Industry) {
        score = score + 50;
      }
      if (auditInfo.Categories) {
        setCategories(JSON.parse(auditInfo.Categories));
      } else {
        setCategories(null);
      }
      setScore(score);
      setLoading(false);
    };
    getScore();
  }, [auditInfo.IsCompanyClaimed, auditInfo.Industry, auditInfo.Categories]);

  if (loading) {
    return (
      <>
        <div className="featureblock-container">
          <div className="card-header">
            <span>{t.title}</span>
          </div>
          <div className="card-graph-body">
            <div className="sumup-category">
              <Skeleton />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="featureblock-container">
          <div className="card-header">
            <span>{t.title}</span>
          </div>
          <div className="card-graph-body">
            <div className="sumup-category">
              <Row>
                <Col xl={10} lg={10} sm={24} className="progress-category">
                  <ProgressCircle type="circle" score={score} />
                </Col>
                <Col xl={14} lg={14} sm={24}>
                  <div style={{ marginTop: "20px" }}>
                    {t.intro}
                  </div>
                </Col>
              </Row>
            </div>
            <div className="criteria-audit">
              <Row gutter={30}>
                <Col xl={13} lg={13} sm={24}>
                  <div className="criteria-status">
                    <span>
                      {auditInfo.IsCompanyClaimed ? (
                        <>
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ✅
                          </span>
                          {t.claimed}{" "}
                        </>
                      ) : (
                        <>
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ❌
                          </span>
                          {t.notClaimed}
                        </>
                      )}
                    </span>
                  </div>
                  <div className="criteria-description">
                    <span>{t.claimedDesc}</span>
                    <br />
                    <br />
                  </div>
                </Col>
                <Col xl={11} lg={11} sm={24}>
                  <img
                    src={claimedImage}
                    width="100%"
                    alt={t.claimedAlt}
                  />
                </Col>
              </Row>
            </div>
            <div className="criteria-audit">
              <Row gutter={30}>
                <Col xl={14} lg={14} sm={24}>
                  <div className="criteria-status">
                    <span>
                      {auditInfo.Industry ? (
                        <>
                          {" "}
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ✅
                          </span>
                          {t.categoryFound}{" "}
                        </>
                      ) : (
                        <>
                          {" "}
                          <span
                            role="img"
                            className="issue-icon"
                            aria-label="emoji"
                          >
                            ❌
                          </span>
                          {t.categoryMissing}
                        </>
                      )}
                    </span>
                  </div>
                  <div className="criteria-description">
                    {auditInfo.Industry ? (
                      <>
                        <span style={{ fontSize: 16 }}>
                          <b>{t.mainCategory(auditInfo.Industry)}</b>
                        </span>
                        <br />
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    <span>{t.categoryDesc}</span>
                    <br />
                    <br />
                    {categories ? (
                      <div className="category-list">
                        <span style={{ fontSize: 17 }}>
                          {t.relatedCategories}
                          <br />
                          <br />
                          <ul>
                            {categories.map((category) => (
                              <li
                                key={category}
                                style={{
                                  listStyle: "none",
                                  paddingBottom: 10,
                                  color: "#3ecb3e",
                                }}
                              >
                                + {category}
                              </li>
                            ))}
                          </ul>
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col xl={10} lg={10} sm={24}>
                  {" "}
                  <img src={category} width="100%" alt={t.categoryAlt} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="featureblock-container-info">
          <div className="card-header">
            <span>{all.didYouKnow}</span>
          </div>
          <div className="card-graph-body">
            <div className="sumup-category">
              <Row>
                <Col xl={18} lg={18} sm={24}>
                  <div className="criteria-status">
                    <span>
                      <span
                        role="img"
                        className="issue-icon"
                        aria-label="emoji"
                      >
                        💡
                      </span>
                      {t.tipTitle}
                    </span>
                  </div>
                  <div className="criteria-description">
                    {t.tip}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default Essentials;
